import { useState, type FormEvent } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Building2, KeyRound, LockKeyhole, Mail } from "lucide-react";
import { post } from "../api/client";
import { Button, Field } from "../components/ui";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const queryClient = useQueryClient();
  const login = useMutation({
    mutationFn: () => post("/api/v1/auth/login", { email, password }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["bootstrap"] });
      window.location.assign("/app");
    }
  });

  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate();
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <header className="login-brand">
          <span className="brand-symbol brand-symbol--large"><span>A</span></span>
          <div><strong>Mój ADIKAM</strong><span>Czas pracy i zespół</span></div>
        </header>
        <div className="login-copy">
          <h1>Zaloguj się</h1>
          <p>Panel zarządzania czasem pracy</p>
        </div>
        <form onSubmit={submit} className="login-form">
          <Field label="Adres e-mail">
            <span className="input-with-icon"><Mail size={17} /><input type="email" autoComplete="username" value={email} onChange={(event) => setEmail(event.target.value)} required /></span>
          </Field>
          <Field label="Hasło">
            <span className="input-with-icon"><LockKeyhole size={17} /><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required autoFocus /></span>
          </Field>
          {login.error ? <p className="form-error">{login.error instanceof Error ? login.error.message : "Nie udało się zalogować."}</p> : null}
          <Button type="submit" variant="primary" icon={<KeyRound size={17} />} disabled={login.isPending}>{login.isPending ? "Logowanie..." : "Zaloguj się"}</Button>
        </form>
        <div className="login-divider"><span>SSO</span></div>
        <Button type="button" icon={<Building2 size={17} />} disabled>Zaloguj przez Microsoft</Button>
      </section>
    </main>
  );
}
